import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TableModule } from '@michelin/theme';

import { CustomerInfoComponent } from './components/customer-info/customer-info.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { LoaderModule } from '@michelin/theme';

@NgModule({
  declarations: [CustomerInfoComponent],
  exports: [CustomerInfoComponent],
  imports: [CommonModule, TableModule, MatFormFieldModule, MatInputModule, MatCardModule, LoaderModule]
})
export class CustomerInfoModule {}
